module.exports = __webpack_public_path__ + "fonts/quicksand-v20-latin-regular.55850f32.eot";